import { gsap } from "@client/gsap";
import { useGSAP } from "@gsap/react";
import React from "react";

import { TickerBlock } from "@reactivated";

import { RichTextBlock } from "../RichText";

import styles from "./homepage.module.scss";

export default function Ticker(props: TickerBlock) {
    const el = React.useRef<HTMLDivElement>(null);
    useGSAP(() => {
        const q = gsap.utils.selector(el.current);
        const slideTween = gsap.to(q(".animate"), {
            translateX: "-66%",
            ease: "none",
            scrollTrigger: {
                trigger: el.current,
                scrub: true,
            },
        });

        return () => slideTween.kill();
    });

    return (
        <div ref={el} className={styles.ticker}>
            <div aria-hidden="true">
                <RichTextBlock className="animate" value={props.text ?? ""} />
            </div>
            &nbsp;
            <RichTextBlock className="animate" value={props.text ?? ""} />
            &nbsp;
            <div aria-hidden="true">
                <RichTextBlock className="animate" value={props.text ?? ""} />
            </div>
        </div>
    );
}
